import sharedStyles from 'styles/css/SharedStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataVipServicesPage } from "reduxx/actions/pages/vipServices";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import { VIP_SERVICES_REQUEST } from 'apis'; 

const VipServices = () => {

    const dispatch = useDispatch();

    const { inputFullname, inputMobile } = useSelector(state => state.vipServices);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        if(name === 'inputMobile')
            dispatch(handleChangeDataVipServicesPage(name, value));
        else
            dispatch(handleChangeDataVipServicesPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

    const handleSubmitForm = (event) => {
        event.preventDefault();

        if(inputFullname.trim().length < 3) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام و نام خانوادگی خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else if(inputMobile.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputMobile.length !== 11)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else {
            if(! isBackdropLoading) {
                apiRequest({
                    dispatch,
                    endpoint: VIP_SERVICES_REQUEST,
                    method: 'post',
                    data: { mobile: inputMobile, fullname: inputFullname },
                    token: null,
                    successMessage: 'درخواست شما با موفقیت ثبت شد',
                    onSuccess: (res) => {
                        dispatch(handleChangeDataVipServicesPage('inputMobile', ''));
                        dispatch(handleChangeDataVipServicesPage('inputFullname', ''));
                        // navigate(`verify`);
                    },
                });
            }

        }
    };

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                

                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary']].join(' ')}>
                    خدمات VIPدکتربیست
                </div>

                <p className={ruleStyles['text-justify']}>
                    ۱. ویزیت الکترونیک و مشاوره پزشکی رایگان و صدور نسخه الکترونیک رایگان به مدت یکسال
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۲. ویزیت تخصصی و فوق تخصصی رایگان (بصورت الکترونیک و یا حتی بصورت ویزیت حضوری در شهر شیراز ) به مدت یکسال (پذیرش و تعیین نوبت توسط گروه Dr20 از بهترین اساتید دانشگاه علوم پزشکی شیراز صورت میگیرد)
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۳. اخذ بلیط رفت و برگشت از هر نقطه از کشور عزیزمان ایران به شیراز به صورت رایگان و ترانسفر فرودگاهی رایگان توسط گروه Dr20
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۴. اقامت در هتل های 5 ستاره شیراز (هتل بزرگ چمران، هتل بزرگ شیراز، هتل بین المللی پارس و هتل ستارگان) به مدت یک هفته به صورت کاملا رایگان
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۵. تور شیراز گردی از جاذبه های توریستی و تفریحی شیراز  (شامل حرم مطهر شاهچراغ، آثار باستانی تخت جمشید و پاسارگاد، آرامگاه لسان الغیب حضرت حافظ شیرازی، آرامگاه سعدی شیرین سخن، مسجد صورتی (Pinkish Mosque) یا مسجد نصیر الملک، باغ ارم، باغ دلگشا، باغ عفیف آباد، بازار وکیل و سرای مشیر، ارگ کریمخانی، نارنجستان قوام).
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۶. ارائه صبحانه و نهار و شام رایگان در طی اقامت یک هفته ای در شیراز  در بهترین رستورانهای شیراز  (رستوران هفت خان، صوفی، رزگلد).
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۷. اهدای سوغات شیراز  و سوغات استان فارس به میهمانان عزیز VIP شامل: الف-غذایی (نان یوخه شیراز، عسل اتحادیه زنبورداران شیراز، انجیر و بادام استهبان، مسقطی لار) ، ب-صنایع دستی (خاتم شیراز، گبه و گلیم و جاجیم، قلم زنی شیراز، منبت کاری شیراز)
                </p>


                <div className={[formStyles['title-2'], formStyles['text-right']].join(' ')} style={{marginBottom: '8px'}}>
                    نکات تکمیلی
                </div>

                <ul className={[ruleStyles['pr-[16px]'], ruleStyles['text-justify']].join(' ')}>
                    <li>
                        ویزیت الکترونیک، مشاوره پزشکی و صدور نسخه الکترونیک، ویزیت تخصصی و فوق تخصصی در طول یک سال برای مشترکین عزیز VIP ، کاملا رایگان است.
                    </li>
                    <li>
                        خدمات بلیط هواپیما (رفت و برگشت) و اقامت در هتل 5 ستاره یک هفته ای و غذا (صبحانه، نهار و شام) برای یک بار در طول سال  به صورت کاملا رایگان جهت  گردشگری شهر شیراز   و یا توریسم درمانی (هم گردشگری شیراز  و هم ویزیت و مداوا در شهر عزیزمان شیراز) قابل استفاده است.
                    </li>
                    <li>
                        جهت اشتراک خدمات VIP دکتر بیست و استعلام قیمت اشتراک، با پشتیبانی دکتر بیست به شماره <a href="tel:+989020843320">09020843320</a> تماس حاصل فرمایید و یا می‌توانید درخواست اشتراک خود را از طریق فرم زیر ثبت نمایید.
                    </li>
                </ul>



                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary'], sharedStyles['mt-[64px]']].join(' ')}>
                    فرم اشتراک خدمات VIP دکتربیست
                </div>
                <div className={[ruleStyles['text-justify'], sharedStyles['mt-[16px]']].join(' ')}>
                    نام و نام خانوادگی
                </div>
                <input type="text" name="inputFullname" value={inputFullname} onChange={handleChangeInputs} className={formStyles.input} placeholder="" />

                <div className={ruleStyles['text-justify']}>
                    شماره موبایل <span className={[sharedStyles['font-weight-900'], sharedStyles['font-[16px]']].join(' ')}>یا</span> تلفن ثابت (با کد شهر مربوطه) <span className={formStyles.required}>ضروری</span>
                </div>
                <input type="tel" name="inputMobile" value={inputMobile} onChange={handleChangeInputs} className={formStyles.input} placeholder="" />
                <button onClick={handleSubmitForm} className={formStyles.button}>ارسال</button>

            </div>
                
        </div>

    );
}

export default VipServices;